
import _ from 'lodash';
import Component from 'vue-class-component';
import Base from './Base.vue';

const BG = ['#000', '#070638', '#500707', '#484848', '#083006', '#3B3212'];

@Component
export default class Mock extends Base {
  autoBackground: string;

  doneInterval = 0;

  constructor() {
    super();
    this.autoBackground = _.sample(BG) || BG[0];
  }

  mounted() {
    this.doneInterval = setInterval(() => {
      this.emitDone();
    }, 4000);
  }

  get background() {
    return this.config.backgroundColor?.toString() || this.autoBackground;
  }

  beforeDestroy() {
    clearInterval(this.doneInterval);
  }
}
